import React from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const MultiBarChart = ({ data }) => {
    // Handle both chart object and direct array
    const chartTitle = data?.title || "User Progress";
    const chartDescription = data?.description || "";
    const chartData = data?.data || data;


    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
        return <p className="text-muted">No data available.</p>;
    }

    // Get all unique metric keys (excluding 'name')
    const metricKeys = [];
    if (chartData.length > 0 && chartData[0].data) {
        chartData[0].data.forEach(item => {
            if (item.key !== 'name') {
                metricKeys.push(item.key);
            }
        });
    }

    // Color palette for bars
    const colors = ['#B0AC92', '#F1C40F', '#7d7', '#F79051', '#1ABC9C',  '#9B59B6'];

    // Transform the data structure dynamically
    const formattedData = chartData.map((item) => {
        // Find the name
        const nameItem = item.data.find(d => d.key === 'name');
        const userName = nameItem?.value || 'Unknown';

        // Build data object dynamically with all metrics
        const dataPoint = {
            name: userName.length > 20 ? userName.substring(0, 20) + '...' : userName,
            fullName: userName,
            id: item.id,
            guid: item.guid,
        };

        // Add all metric values dynamically
        item.data.forEach(dataItem => {
            if (dataItem.key !== 'name') {
                // Create a safe key name for the data point
                const safeKey = dataItem.key.replace(/\s+/g, '_').toLowerCase();
                dataPoint[safeKey] = dataItem.value || 0;
                // Store the original key for display
                dataPoint[`${safeKey}_label`] = dataItem.key;
            }
        });

        return dataPoint;
    });

    // Custom tooltip styled like Bootstrap tooltip
    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                <div className="tooltip bs-tooltip-top show" role="tooltip" style={{ position: 'relative', opacity: 1 }}>
                    <div className="tooltip-inner" style={{ maxWidth: '300px', textAlign: 'left' }}>
                        <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                            {data.fullName}
                        </div>
                        <div style={{ fontSize: '0.9em' }}>
                            {metricKeys.map((metricKey, index) => {
                                const safeKey = metricKey.replace(/\s+/g, '_').toLowerCase();
                                return (
                                    <div key={index}>
                                        {metricKey}: {data[safeKey]}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="my-4">
            {/* Row 1: Title and Description */}
            {/*<Row className="mb-3">*/}
            {/*    <Col>*/}
            {/*        <h4 className="mb-1">{chartTitle}</h4>*/}
            {/*        {chartDescription && (*/}
            {/*            <p className="text-muted small mb-0">{chartDescription}</p>*/}
            {/*        )}*/}
            {/*    </Col>*/}
            {/*</Row>*/}

            {/* Row 2: Chart */}
            <Row>
                <Col xs={12}>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart
                            data={formattedData}
                            margin={{ top: 5, right: 30, left: 10, bottom: 50 }}
                        >
                            <Legend verticalAlign="top" height={30} />
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                                dataKey="name"
                                angle={-45}
                                textAnchor="end"
                                height={80}
                                interval={0}
                                style={{ fontSize: '13px' }}
                            />
                            <YAxis />
                            <Tooltip content={<CustomTooltip />} />
                            {metricKeys.map((metricKey, index) => {
                                const safeKey = metricKey.replace(/\s+/g, '_').toLowerCase();
                                return (
                                    <Bar
                                        key={safeKey}
                                        dataKey={safeKey}
                                        fill={colors[index % colors.length]}
                                        name={metricKey}
                                        radius={[2, 2, 0, 0]}
                                    />
                                );
                            })}
                        </BarChart>
                    </ResponsiveContainer>
                </Col>
            </Row>
        </div>
    );
};

export default MultiBarChart;